import { Commission } from '../../pages';
import React, { useState } from 'react';
import { observer } from 'mobx-react';

const CommissionContainer = () => {
	const [tableType, setTableType] = useState('Commissions');
	const [comTypeModal, setComTypeModal] = useState(false);
	const [saleSheetModal, setSaleSheetModal] = useState(false);

	const showComTypeModal = () => {
		setComTypeModal(true);
	};

	const showSaleSheetModal = () => {
		setSaleSheetModal(true);
	};

	const closeModal = () => {
		setComTypeModal(false);
		setSaleSheetModal(false);
	};

	return (
		<Commission
			tableType={tableType}
			setTableType={setTableType}
			comTypeModal={comTypeModal}
			saleSheetModal={saleSheetModal}
			showComTypeModal={showComTypeModal}
			showSaleSheetModal={showSaleSheetModal}
			closeModal={closeModal}
		/>
	);
};

export default observer(CommissionContainer);
